import { axiosInstance as axios } from "services";

export const fetchCartingOptions = async () => {
  const { data } = await axios.get("/pricing/master/carting/options");
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch carting options");
  return data;
};
